export default __webpack_public_path__ + "static/mata-219a61c1c11099c6b648106c78e00ab4.jpg";